// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_6q-4";
export var collapsed = "_6q-1";
export var headerBar = "_6q-0";
export var leftHeaderContent = "_6q-3";
export var subjectContainer = "_6q-2";